import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface AuroraInputProps {
  onAuroraChange: (value: string) => void;
  auroraValue: string;
  isEnabled: boolean;
}

export const AuroraInput: React.FC<AuroraInputProps> = ({
  onAuroraChange,
  auroraValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="AURORA"
      label="Enter AURORA details:"
      placeholder="Enter Aurora information..."
      value={auroraValue}
      onChange={onAuroraChange}
      isEnabled={isEnabled}
    />
  );
};